import parse from 'html-react-parser'
import {
    AspectRatio,
    BackgroundImage,
    Button,
    Grid,
    Stack,
} from '@mantine/core'
const ContentTypeArticle = ({ data }) => {
    return (
        <Grid gutter='2x'>
            <Grid.Col xl={3}>
                <Stack spacing='2x'>
                    <AspectRatio ratio={1}>
                        <BackgroundImage src={data.media.coverImage.src} />
                    </AspectRatio>
                    <Stack>
                        {data.links.map((link) => (
                            <Button
                                component='a'
                                fullWidth
                                href={link.url}
                                radius='sm'
                                rel='noopener noreferrer'
                                target='_blank'
                            >
                                {link.label}
                            </Button>
                        ))}
                    </Stack>
                </Stack>
            </Grid.Col>
            <Grid.Col xl={9}>{parse(data.description)}</Grid.Col>
        </Grid>
    )
}
export default ContentTypeArticle
